/** True when the visitor asked the operating system to minimise motion. */
export const prefersReducedMotion = () =>
  typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/** True where elements can be animated with element.animate() (the Web Animations API); jsdom cannot. */
export const supportsWebAnimations = () =>
  typeof Element !== "undefined" && typeof Element.prototype.animate === "function";
